import type { FC } from "react";
import LandingPage from "../landingpage/LandingPage";
import { BaseContainer } from "./App.style";
import { Helmet } from "react-helmet-async";

const App: FC = () => {
    return (
        <BaseContainer>
            <Helmet>
                <title>Free Online Developer Tools for Everyday Use. Your elite all-in-one online toolbox for developers — fast, minimal, and powerful.</title>
                <meta name="description" content="Your elite all-in-one online toolbox for developers — fast, minimal, and powerful. Your all-in-one online toolbox for developers, featuring essential tools like JSON Formatter, JWT Decoder, Base64 Encoder/Decoder, HTML & XML Formatter, Text Diff Checker, Text Comparator, Word/Character/Sentence Counter, CRON Expression Generator, and UUID Generator (v4, v5, v7)." />
                <meta name="keywords" content="developer tools, online tools, dev utilities, JSON formatter, JWT decoder, Base64 encoder, UUID generator, web dev tools, all-in-one online toolbox for developers, featuring essential tools like JSON Formatter, JWT Decoder, Base64 Encoder/Decoder, HTML & XML Formatter, Text Diff Checker, Text Comparator, Word/Character/Sentence Counter, CRON Expression Generator, and UUID Generator (v4, v5, v7)." />
            </Helmet>
            <LandingPage />
        </BaseContainer>
    )

}

export default App;